import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export type UserPlantRequest = {
  userId: string;
  plantId: string;
  isDefault?: boolean;
};

export default class PlantUserApi {
  static async GetPlantsByUser(userId: string): Promise<any> {
    return ApiHandler(baseURL).get(
      `/userplant/getbyuserid?userId=${encodeURIComponent(userId)}`,
    );
  }

  static async AssignPlants(requests: UserPlantRequest[]): Promise<any> {
    if (!Array.isArray(requests) || requests.length === 0) {
      return Promise.resolve(null);
    }

    const sanitized = requests
      .map((request) => {
        const userId = (request?.userId ?? "").trim();
        const plantId = (request?.plantId ?? "").trim();
        if (!userId || !plantId) {
          return null;
        }

        return {
          userId,
          plantId,
          isDefault: Boolean(request?.isDefault),
        } as UserPlantRequest;
      })
      .filter((entry): entry is UserPlantRequest => Boolean(entry));

    if (sanitized.length === 0) {
      return Promise.resolve(null);
    }

    return ApiHandler(baseURL).post(`/userplant`, sanitized);
  }

  static async RemovePlants(payload: { userId: string; plantIds: string[] }): Promise<any> {
    const { userId, plantIds } = payload;
    const trimmedUserId = (userId ?? "").trim();
    if (!trimmedUserId || !Array.isArray(plantIds) || plantIds.length === 0) {
      return Promise.resolve(null);
    }

    const promises = plantIds.map((plantId) => {
      const trimmedPlantId = (plantId ?? "").trim();
      if (!trimmedPlantId) {
        return Promise.resolve(null);
      }

      return ApiHandler(baseURL).delete(
        `/userplant/deleteuserplant?userId=${encodeURIComponent(
          trimmedUserId,
        )}&plantIds=${encodeURIComponent(trimmedPlantId)}`,
      );
    });

    return Promise.all(promises);
  }
}
